import { createIcon } from './Icon'

// Do not modify this file as it was auto-generated by update-icons.mjs
export default createIcon(
  'CheckMarkBoldIcon',
  'check-mark-bold',
  'M898.719 731.698c30.51-31.336 30.51-82.143 0-113.479l-441.964-453.918c-30.511-31.334-79.98-31.334-110.491 0l-220.981 226.959c-30.511 31.334-30.511 82.143 0 113.479s79.98 31.336 110.491 0l165.735-170.219 386.715 397.177c30.515 31.336 79.98 31.336 110.495 0z',
)
